export default "__VITE_ASSET__CQTpXCsQ__"